import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import TextList from '../../Partials/TextList/TextList';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../../Config';
import { buildUrlAndOpenSameWindow, buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import Support from '../../Partials/Support/Support';
import PopUp from '../../../../Shared/Popup/PopUp';
import GetQrCodeErrorPopUp from '../../Partials/GetQrCodeErrorPopUp/GetQrCodeErrorPopUp';
import { goToPage, setIsGetQrCodeError, reportDWH } from '../../EsimQrCodeBlockSlice';
import { getQrCodeAsync, validatePhoneNumber } from '../../EsimQrCodeBlockAsyncThunk';
import { GetUserDetails } from '../../../IdfSaleBlock/IdfSaleSlice';
import { gtag4 } from '../../../../../utilities/analytics/tracking';
import { isNullOrEmpty } from "../../../../../utilities/StringHelpers/StringHelpers";
import qrIcon from '../InstallEsimOnMobilePage/images/qr-icon.svg';
import barcodeFrame from './images/barcode-frame.svg';
import lightIconSmall from './images/light-icon-small.svg';
import infoIcon from './images/info-icon.svg';
import './InstructionsPage.scss';

const WIFI_INSTRUCTION_TEXT = 'יש לוודא שהנייד בו מפעילים את ה-eSIM מחובר ל-WiFi ולהמשיך להפעלת ה-eSIM';

const getInstructionsPageTextList = (textList) => {
    if (!textList?.length) {
        return [];
    }

    return textList.map((item) => (
        item.icon === 3 ? { ...item, text: WIFI_INSTRUCTION_TEXT } : item
    ));
};

const InstructionsPage = (props) => {
    const [isConfirmDisconnectLine, setIsConfirmDisconnectLine] = useState(false);
    const [isDisplayDisconnectPopup, setIsDisplayDisconnectPopup] = useState(props.isAdvanceOrder && !isConfirmDisconnectLine);
    const [isDisplayPopupInfo, setIsDisplayPopupInfo] = useState(false);
    const [hideEsimInstructions , setHideEsimInstructions] = useState(false);


    // Determine if this is an IDF customer and get the correct phone number
    const isIdfCustomer = props.authentication?.loginData?.userDetails?.RoleList?.some(role => role.startsWith('IDFOTP')) ?? false;
    const idfPhoneNumber = props.idfStore?.userDetails?.existing_line_code !== "" ? props.idfStore?.userDetails?.existing_line_code : props.idfStore?.userDetails?.new_line_code;
    const displayPhoneNumber = isIdfCustomer
        ? validatePhoneNumber(idfPhoneNumber)
        : props.subscriberNo;

    useEffect(() => {
        gtag4({ event: 'EsimLine_Step1_QrActivatePage', step: '1', action: 'QrActivatePage' });
        props.reportDWH({ actionType: 'eSIM QR Activation Page', status: 'Ongoing', messageText: 'eSIM QR Activation Page Displayed' });
        const isHideEsimInstructions = localStorage.getItem('HideEsimInstructions');
        if (isHideEsimInstructions) {
            localStorage.removeItem('HideEsimInstructions');
            setHideEsimInstructions(true);
        }
    }, []);

    // Get IDF user details if this is an IDF customer and we don't have the details yet
    useEffect(() => {
        const fetchIdfUserDetails = async () => {
            if (isIdfCustomer && isNullOrEmpty(props.idfStore.userDetails)) {
                await props.GetUserDetails();
            }
        };

        fetchIdfUserDetails();
    }, [isIdfCustomer, props.idfStore.userDetails]);

    const instructionsPageTextList = getInstructionsPageTextList(props.instructionsPageTextList);

    return (
        <div className='instructions-page-wrapper'>
            <div className='instructions-page'>
                <div className='title'> הפעלה עם קוד QR </div>
                <div className='sub-title'> למספר {displayPhoneNumber} </div>
                {
                  (!hideEsimInstructions && instructionsPageTextList.length > 0) &&
                  <>
                    <TextList textList={instructionsPageTextList} />
                    <div className='remark-wrapper' style={{ '--remark-light-icon': lightIconSmall.bg() }}>
                        <span> יש כבר eSIM מותקן על המכשיר? </span>
                        <a
                            href='#'
                            className='info-icon'
                            style={{ backgroundImage: infoIcon.bg() }}
                            onClick={(e) => { e.preventDefault(); setIsDisplayPopupInfo(true); }}
                        />
                    </div>
                  </>
                }

                <div className='seperator'></div>

                <div className='barcode-wrapper'>
                    <div className={`barcode-borders ${props.base64QrCode ? 'barcode-borders--has-qr' : ''}`}>
                        <Image src={barcodeFrame} alt='' className='barcode-borders__frame' aria-hidden='true' />
                        <div className='barcode-borders__inner'>
                            {
                                props.base64QrCode ? (
                                    <Image src={'data:image/png;base64, ' + props.base64QrCode} className='barcode-borders__qr-image' />
                                ) : (
                                    <button type='button' className='barcode-preview' onClick={handleDisplayQrCode}>
                                        <Image src={qrIcon} alt='' className='barcode-preview__icon' />
                                        <span className='barcode-preview__text'>
                                            <span className='barcode-preview__text-line'>לחצו להצגת הקוד</span>
                                            <span className='barcode-preview__text-line'>לסריקה במכשיר</span>
                                            <span className='barcode-preview__text-line'>המיועד להפעלה</span>
                                        </span>
                                        {props.isLoadingQrCode && <span className='small-loader'></span>}
                                    </button>
                                )
                            }
                        </div>
                    </div>
                </div>

                {/* <div className='download-apps-wrapper'>
                    <div className='app-links-title'> ניתן גם להוריד את האפליקציה ישירות בחנות </div>
                    <div className='app-links'>
                        <a href='#' onClick={(e) => { handleDownloadIos(e) }} className='apple-icon'><span>App store</span></a>
                        <a href='#' onClick={(e) => { handleDownloadAndroid(e) }} className='android-icon'><span>Google Play</span></a>
                    </div>
                    <div className='link-wrapper'> <a href='#' onClick={(e) => handleGoToVideoPage(e)}>לצפייה בסרטון הוראות הפעלה</a> </div>
                </div> */}

                <div className='seperator'></div>

                <div className='mobile-instructions-wrapper'>
                    <div className='link-wrapper'>
                        <a href='#' onClick={(e) => { e.preventDefault(); handleScanQrFromMobile(); }}>
                            להוראות הפעלה במכשיר שלי
                        </a>
                    </div>
                </div>
                <div className='seperator'></div>
                <div className='options-wrapper'>
                    <div className='options-title'> אין באפשרותך לסרוק? <br /> ניתן להפעיל את ה-eSIM עם קודי הפעלה </div>
                    <div className='button-wrapper'>
                        <BtnSubmit
                            isBusiness={false}
                            text='להפעלה באמצעות קודי הפעלה'
                            onclick={handlePageContinue}
                            formid='esim-qr-code-block'
                            isDisplayArrows={false}
                            isDisplayWhatsAppIcon={false}
                        />
                    </div>
                </div>
                <div className='seperator'></div>
                <Support />
            </div>
            <PopUp showPopUp={isDisplayDisconnectPopup} onClose={() => setIsDisplayDisconnectPopup(false)} footerBtn={{ text: 'מאושר, אפשר להתקדם', onBtnClick: handlePopupConfirmDisconnect }}>
                <div className='popup-disconnect-line'>
                    <div className='popup-image'><Image src={require('./images/light-icon.svg')} /></div>
                    <div className='popup-title'> חשוב לדעת <br /> במעבר לעמוד הוראות ההפעלה קו הסלולר שלך יתנתק </div>
                    <div className='custom-scrollbar'>
                        <div className='popup-text' dangerouslySetInnerHTML={{ __html: props.disconnectLinePopupText }}></div>
                    </div>
                </div>
            </PopUp>

            <PopUp showPopUp={isDisplayPopupInfo} onClose={() => setIsDisplayPopupInfo(false)} footerBtn={{ text: 'הבנתי, תודה!', onBtnClick: () => setIsDisplayPopupInfo(false) }}>
                <div className='popup-delete-esim'>
                    <div className='popup-image'><Image src={require('./images/light-icon.svg')} /></div>
                    <div className='popup-title'> כיבוי eSIM קיים להשלמת ההתקנה </div>
                    <div>
                        <div className='popup-text' dangerouslySetInnerHTML={{ __html: props.deleteEsimPopupText }}></div>
                    </div>
                </div>
            </PopUp>

            <GetQrCodeErrorPopUp
                show={props.isGetQrCodeError}
                onClose={() => props.setIsGetQrCodeError(false)}
            />

        </div>
    );

    function handlePopupConfirmDisconnect() {
        setIsDisplayDisconnectPopup(false);
        setIsConfirmDisconnectLine(true);
    }

    async function handleDisplayQrCode(e) {
        if (e?.preventDefault) {
            e.preventDefault();
        }

        if (props.isAdvanceOrder && !isConfirmDisconnectLine) {
            setIsDisplayDisconnectPopup(true);
            return;
        }

        props.reportDWH({ actionType: 'eSIM QR Activation Page', status: 'Ongoing', messageText: 'eSIM QR Clicked' });
        if (!props.base64QrCode) {
            const result = await props.getQrCodeAsync();
            const isSuccess = (result?.payload?.Header?.ReturnCode == 0 && result?.payload?.Body?.successResult?.isSuccess);
            const base64QrCode = result?.payload?.Body?.SUBSCRIBER_DETAILS?.[0]?.QRCODE;

            if (isSuccess && base64QrCode) {
                props.reportDWH({ actionType: 'eSIM QR Revealed', status: 'Completed', messageText: 'Success' });
            } else {
                props.reportDWH({ actionType: 'eSIM QR Revealed', status: 'Error', messageText: 'General Error' });
            }
        }
    }

    function handleGoToVideoPage(e) {
        e.preventDefault();
        gtag4({ event: 'EsimLine_Step1_QrActivateInfoVideo', step: '1', action: 'QrActivateInfoVideo' });
        props.reportDWH({ actionType: 'Activaion Page - QR', status: 'Ongoing', messageText: 'Show instruction Movie- Clicked' });
        props.goToPage('videoPage');
    }

    function handleDownloadIos(e) {
        e.preventDefault();
        buildUrlAndOpenSameWindow(Config.appleStoreNavigation);
    }

    function handleDownloadAndroid(e) {
        e.preventDefault();
        buildUrlAndOpenSameWindow(Config.googlePlayNavigation);
    }

    async function handlePageContinue() {
        gtag4({ event: 'EsimLine_Step1_QrActivateCode', step: '1', action: 'QrActivateCode' });
        props.reportDWH({ actionType: 'eSIM QR Activation Page', status: 'Ongoing', messageText: 'eSIM Activation Code Button Clicked' });

        if (props.isAdvanceOrder && !isConfirmDisconnectLine) {
            setIsDisplayDisconnectPopup(true);
            return;
        }

        const result = await props.getQrCodeAsync({ isDisplayLoader: true });
        console.info('handlePageContinue', result);
        const isSuccess = (result?.payload?.Header?.ReturnCode == 0 && result?.payload?.Body?.successResult?.isSuccess);

        if (isSuccess) {
            props.goToPage('activationCodesPage');
        }
    }

    function handleScanQrFromMobile() {
        gtag4({ event: 'EsimLine_Step1_QrActivateCode', step: '1', action: 'QrActivateCode' });
        props.reportDWH({ actionType: 'eSIM QR Activation Page', status: 'Ongoing', messageText: 'eSIM Scan QR from Mobile Button Clicked' });
        buildUrlAndOpenWindow(props.scanQrFromMobileUrl);
    }

};

const mapStateToProps = (state) => {
    return {
        subscriberNo: state.esimQrCodeBlock.loginDetails.subscriberNo,
        isLoadingQrCode: state.esimQrCodeBlock.isLoadingQrCode,
        isGetQrCodeError: state.esimQrCodeBlock.isGetQrCodeError,
        base64QrCode: state.esimQrCodeBlock.qrCodeDetails.base64QrCode,
        deleteEsimPopupText: state.esimQrCodeBlock.esimBlockData.deleteEsimPopupText,
        instructionsPageTextList: state.esimQrCodeBlock.esimBlockData.instructionsPageTextList,
        disconnectLinePopupText: state.esimQrCodeBlock.esimBlockData.disconnectLinePopupText,
        isAdvanceOrder: state.esimQrCodeBlock.esimBlockData.isAdvanceOrder,
        scanQrFromMobileUrl: state.esimQrCodeBlock.esimBlockData.scanQrFromMobileUrl,
        idfStore: state.idfSale,
        authentication: state.authentication
    };
};

const mapDispatchToProps = {
    goToPage,
    setIsGetQrCodeError,
    reportDWH,
    getQrCodeAsync,
    GetUserDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(InstructionsPage);
